import { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import css from './index.module.css';
import Content from '@components/adminNavigation';
import axios from "axios";
import * as Types from '../../../types';
import { toast } from 'sonner';
import SEO from '@components/seo';

export default function AdmOrganization() {
  const { id } = useParams();
  const [organization, setOrganization] = useState<Types.Organization>();
  const navigate = useNavigate();
  
  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_ADM_URL}/organization/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    }).then(response => {
      setOrganization(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setOrganization((prev) => {
      if (!prev) return prev;

      const keys = name.split('[').map((key: any) => key.replace(']', ''));

      if (keys.length === 1) {
        return {
          ...prev,
          [keys[0]]: value,
        };
      }

      if (keys.length === 2) {
        return {
          ...prev,
          [keys[0]]: {
            ...(prev as any)[keys[0] as keyof typeof prev],
            [keys[1]]: value,
          },
        };
      }

      return prev;
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/organizations/${id}`, organization, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
    })
    .then(_ => {
      toast.success('Информация обновлена')
    })
    .catch(error => {
      console.log(error);
      toast.error('Ошибка');
    });
  };

  return (
    <Content>
      <SEO 
        title={'Управление организацией'}
        description={'Админ-панель'}
        ogUrl={`https://рыбныимир.рф`}
      />

      <h1 className={css.head}>{organization?.name}</h1>
      <form onSubmit={handleSubmit}>
        <b className={css.headAcc}>Данные организации</b>

        {organization?.isDeleted && (
          <div className={css.deletedInfo}>
            <b>Организация удалена</b>
            <p>Организация была помечена как удаленная. Пользователь не сможет использовать её для доставки заказов.</p>
          </div>
        )}

        <div className={css.inputGrid}>
          <label>Наименование организации</label>
          <input name='name' type='text' placeholder='Наименование организации' value={organization?.name} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Тип организации</label>
          <select name='type' value={organization?.type} onChange={handleChange}>
            <option value='LEGAL'>Юридическое лицо</option>
            <option value='INDIVIDUAL'>Физическое лицо (ИП, НПД)</option>
          </select>
        </div>

        <div className={css.inputGrid}>
          <label>ИНН</label>
          <input name='inn' type='text' placeholder='ИНН' value={organization?.inn} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>ОГРН</label>
          <input name='ogrn' type='text' placeholder='ОГРН' value={organization?.ogrn} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Адрес организации</label>
          <input name='address' type='text' placeholder='Адрес организации' value={organization?.address} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Статус организации</label>
          <select name='status' value={organization?.status} onChange={handleChange}>
            <option value='ACTIVE'>Действующая</option>
            <option value='INACTIVE'>Ликвидирована</option>
          </select>
        </div>

        <div className={css.user} onClick={() => navigate(`/manage/user/${organization?.user?.id}`)}>
          <a>Привязана к пользователю</a>
          <div><span>Имя пользователя:</span> <b>{organization?.user?.username || "Не привязана"}</b></div>
          <div><span>Телефон:</span> <b>{organization?.user?.phone || "Не привязана"}</b></div>
        </div>

        <button className={css.saveBtn} type='submit'>Сохранить изменения</button>
      </form>
    </Content>
  );
}
